import type React from "react";

export type FmuLogoProps = {
    className?: string;
    style?: React.CSSProperties;
};

export function FmuLogo(props: FmuLogoProps): React.ReactNode {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 468.8 476.6" fill="currentColor" {...props}>
            <path d="M182.5,1c-2.3-2.1-6-.6-6.2,2.5l-4.5,67.9c-.1,2-1.9,3.6-3.9,3.5l-79.3-4.7c-3.5-.2-5.3,4.1-2.7,6.5l141.6,126.1c2.4,2.1,6.2.4,6.2-2.8l.4-149.9c0-1,.3-2.8-.5-3.6L182.5,1Z" />
            <circle cx="142.7" cy="42.9" r="16.7" />
            <path d="M200.4,219.4l-129.6-75.3c-.9-.5-2.3-1.7-3.3-1.4L2.6,164.2c-3,.9-3.5,4.9-1,6.6l56.5,37.9c1.7,1.1,2.2,3.4,1,5.1l-43.8,66.3c-1.9,2.9.9,6.7,4.3,5.6l180-59.6c3-1,3.5-5.1.7-6.7h0Z" />
            <circle cx="20.2" cy="219.3" r="16.7" />
            <path d="M267.3,218.8l130-74.6c.9-.5,2.6-1.2,2.8-2.2l13.9-66.9c.7-3-2.5-5.5-5.3-4.1l-61,30c-1.8.9-4,.2-5-1.7l-35.6-71.1c-1.6-3.1-6.2-2.5-7,.9l-38.5,185.7c-.6,3.1,2.7,5.6,5.5,4h0Z" />
            <circle cx="358.6" cy="61.4" r="16.7" />
            <path d="M286.2,475.6c2.3,2.1,6,.6,6.2-2.5l4.5-67.9c.1-2,1.9-3.6,3.9-3.5l79.3,4.7c3.5.2,5.3-4.1,2.7-6.5l-141.6-126.1c-2.4-2.1-6.2-.4-6.2,2.8l-.4,149.9c0,1-.3,2.8.5,3.6l51,45.5Z" />
            <circle cx="326.1" cy="433.7" r="16.7" />
            <path d="M268.4,257.2l129.6,75.3c.9.5,2.3,1.7,3.3,1.4l64.9-21.5c3-.9,3.5-4.9,1-6.6l-56.5-37.9c-1.7-1.1-2.2-3.4-1-5.1l43.8-66.3c1.9-2.9-.9-6.7-4.3-5.6l-180,59.6c-3,1-3.5,5.1-.7,6.7h0Z" />
            <circle cx="448.6" cy="257.3" r="16.7" />
            <path d="M201.5,257.8l-130,74.6c-.9.5-2.6,1.2-2.8,2.2l-13.9,66.9c-.7,3,2.5,5.5,5.3,4.1l61-30c1.8-.9,4-.2,5,1.7l35.6,71.1c1.6,3.1,6.2,2.5,7-.9l38.5-185.7c.6-3.1-2.7-5.6-5.5-4h0Z" />
            <circle cx="110.2" cy="415.2" r="16.7" />
        </svg>
    );
}
